import { createAction, props } from '@ngrx/store';
import { TestReportPayload, TestReportSummarization } from '../../models/test-report-summarization';

// Trigger API call to load Test Report Summarization
const loadTestReportSummarization = createAction(
  '[Test Report Summarization] Load',
  props<TestReportPayload>()
);

// API call success
const loadTestReportSummarizationSuccess = createAction(
  '[Test Report Summarization] Load Success',
  props<{ metadata: any , testReport: TestReportSummarization[] }>()
);

// API call failure
const loadTestReportSummarizationFailure = createAction(
  '[Test Report Summarization] Load Failure',
  props<{ error: any }>()
);

const loadTestReportSummarizationById = createAction(
  '[Test Report Summarization] Get Summary By Id',
  props<{data: TestReportPayload, releaseId:any}>()
);

export const resetDashboardConfig = createAction('[Test Report Summarization] Reset Config');


export const TestReportSummarizationActions = {
    loadTestReportSummarization,
    loadTestReportSummarizationSuccess,
    loadTestReportSummarizationFailure,
    loadTestReportSummarizationById,
    resetDashboardConfig
};
  
